import React, { lazy } from 'react';
import { scrollToPurchase } from '../utils/scroll';
const BONUSES = [{
  num: '1',
  title: 'El Diagnóstico Anti-Visto',
  subtitle: 'Detecta el punto exacto donde se mueren tus ventas y arréglalo hoy.',
  desc: 'Analiza tu último chat de ventas con este protocolo de 10 minutos y descubre exactamente en qué momento perdiste al cliente y por qué.',
  value: '$27.00',
  img: 'https://cdn.magicpatterns.com/uploads/pMQfMHG4tMguqw8CQVxdta/portada_bono_1_a4.png'
}, {
  num: '2',
  title: 'La Oferta Irresistible en 1 Página',
  subtitle: 'Plantilla + 5 Ejemplos Reales.',
  desc: 'La plantilla exacta para construir una oferta que el cliente no pueda rechazar lógicamente. Con 5 ejemplos de negocios reales aplicados.',
  value: '$37.00',
  img: 'https://cdn.magicpatterns.com/uploads/qeg4G3AqgfYwX5qu2WjFpG/bono_2_portada_a4.png'
}, {
  num: '3',
  title: 'Banco de Prueba Social',
  subtitle: '21 Testimonios-Plantilla + Cómo Pedirlos Sin Vergüenza.',
  desc: 'Cómo recolectar testimonios que vendan por ti, qué preguntas hacerle a tu cliente para que su respuesta sea tu mejor argumento de venta.',
  value: '$27.00',
  img: 'https://cdn.magicpatterns.com/uploads/7LRxibAYjTbAbyM1DxdiVp/portada_bono_3_a4.png'
}];
export function Bonuses() {
  return <section className="bg-brand-white px-4 py-20 sm:px-6 lg:px-8" data-id="element-15">
      <div className="mx-auto max-w-5xl" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <div className="mb-6 inline-block rounded-full bg-brand-gold/20 px-6 py-2 text-sm font-bold text-brand-gold border border-brand-gold/30" data-id="element-18">
            🎁 BONOS GRATUITOS INCLUIDOS
          </div>
          <h2 className="text-3xl font-bold text-brand-black sm:text-4xl" data-id="element-19">
            Tres herramientas adicionales que aceleran tus resultados:
          </h2>
        </div>

        <div className="space-y-12" data-id="element-20">
          {BONUSES.map((bono, idx) => <div key={idx} className="overflow-hidden rounded-2xl border-2 border-brand-gold bg-white shadow-xl flex flex-col md:flex-row" data-id="element-21">
              <div className="md:w-2/5 cursor-pointer relative group" onClick={scrollToPurchase} data-id="element-22">
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-10" data-id="element-23">
                  <span className="bg-brand-green text-brand-black font-bold px-4 py-2 rounded-lg" data-id="element-24">
                    Obtener Gratis
                  </span>
                </div>
                <img src={bono.img} alt={bono.title} className="h-full w-full object-cover" width="1080" height="1080" loading="lazy" decoding="async" data-id="element-25" />
              </div>
              <div className="p-8 md:w-3/5 flex flex-col justify-center" data-id="element-26">
                <div className="mb-2 text-sm font-bold tracking-widest text-brand-gold" data-id="element-27">
                  BONO {bono.num} DE 3
                </div>
                <h3 className="mb-3 text-2xl font-bold text-brand-black" data-id="element-28">
                  {bono.title}
                </h3>
                <p className="mb-4 text-lg font-medium text-gray-800 italic" data-id="element-29">
                  {bono.subtitle}
                </p>
                <p className="mb-8 text-gray-600" data-id="element-30">{bono.desc}</p>
                <div className="mt-auto bg-gray-50 p-4 rounded-lg border border-gray-100 flex items-center justify-between" data-id="element-31">
                  <span className="text-gray-500 line-through" data-id="element-32">
                    VALOR REAL: {bono.value}
                  </span>
                  <span className="font-black text-brand-green text-xl uppercase" data-id="element-33">
                    INCLUIDO GRATIS HOY
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}